import React, { PureComponent } from 'react';
import broken from '../../images/broken-string-guitar-broken.gif'

export default class PageNotFound extends PureComponent {
  render() {
    return (
      <div className="common-page-not-found" style={{padding:"8px"}}>
        404. Seite nicht gefunden.<br />
        <img src={broken} alt="broken" /> <br />
        <br />
        <a href={window.location.host}>Hier</a> geht es zur Planungs-Website.
      </div>
    );
    
  }
}



// WEBPACK FOOTER //
// ./src/features/common/PageNotFound.js